import { DefaultState, DropdownItem } from 'store/types';

export const EXPORT_JOBS_FILTERS_REQUEST = 'EXPORT_JOBS_FILTERS_REQUEST';
export const EXPORT_JOBS_FILTERS_SUCCESS = 'EXPORT_JOBS_FILTERS_SUCCESS';
export const EXPORT_JOBS_FILTERS_FAILURE = 'EXPORT_JOBS_FILTERS_FAILURE';

export interface ExportJobsFiltersData {
  dates: Array<DropdownItem>;
  statuses: Array<DropdownItem>;
  types: Array<DropdownItem>;
}

export type ExportJobsFiltersState = DefaultState & {
  contents?: ExportJobsFiltersData;
};

interface ExportJobsFiltersRequest {
  type: typeof EXPORT_JOBS_FILTERS_REQUEST;
}

interface ExportJobsFiltersSuccess {
  type: typeof EXPORT_JOBS_FILTERS_SUCCESS;
  contents: ExportJobsFiltersData;
}

interface ExportJobsFiltersFailure {
  type: typeof EXPORT_JOBS_FILTERS_FAILURE;
}

export type ExportJobsFiltersActionTypes =
  | ExportJobsFiltersRequest
  | ExportJobsFiltersSuccess
  | ExportJobsFiltersFailure;
